import { apiConnector } from "../apiconnector"
import { assessmentEndpoints } from "../apis"

const {
  CHECK_ELIGIBILITY_API,
  GET_ASSESSMENT_API,
  GET_ATTEMPT_API,
  SUBMIT_MCQ_API,
  SUBMIT_CODE_API,
  SUBMIT_PROJECT_API,
  GET_CERTIFICATES_API,
  GET_CERTIFICATE_API,
  VERIFY_CERTIFICATE_API,
  CREATE_ASSESSMENT_API,
  ADMIN_CREATE_ASSESSMENT_API,
  GET_INSTRUCTOR_ASSESSMENT_API,
  GET_ADMIN_ASSESSMENT_API,
} = assessmentEndpoints

const headers = (token) => ({ Authorization: `Bearer ${token}` })

export const checkEligibility = async (courseId, token) => {
  try {
    const res = await apiConnector("GET", CHECK_ELIGIBILITY_API(courseId), null, headers(token))
    return res.data
  } catch { return { success: false } }
}

export const getAssessment = async (courseId, token) => {
  try {
    const res = await apiConnector("GET", GET_ASSESSMENT_API(courseId), null, headers(token))
    return res.data
  } catch { return { success: false } }
}

export const getAttempt = async (courseId, token) => {
  try {
    const res = await apiConnector("GET", GET_ATTEMPT_API(courseId), null, headers(token))
    return res.data
  } catch { return { success: false } }
}

export const submitMCQ = async (courseId, answers, token) => {
  try {
    const res = await apiConnector("POST", SUBMIT_MCQ_API(courseId), { answers }, headers(token))
    return res.data
  } catch (e) { return { success: false, message: e.message } }
}

export const submitCode = async (courseId, code, token) => {
  try {
    const res = await apiConnector("POST", SUBMIT_CODE_API(courseId), { code }, headers(token))
    return res.data
  } catch (e) { return { success: false, message: e.message } }
}

export const submitProject = async (courseId, data, token) => {
  try {
    const res = await apiConnector("POST", SUBMIT_PROJECT_API(courseId), data, headers(token))
    return res.data
  } catch (e) { return { success: false, message: e.message } }
}

export const getMyCertificates = async (token) => {
  try {
    const res = await apiConnector("GET", GET_CERTIFICATES_API, null, headers(token))
    return res.data?.data ?? []
  } catch { return [] }
}

export const getCertificateForCourse = async (courseId, token) => {
  try {
    const res = await apiConnector("GET", GET_CERTIFICATE_API(courseId), null, headers(token))
    return res.data?.data ?? null
  } catch { return null }
}

export const createAssessment = async (courseId, payload, token, isAdmin = false) => {
  try {
    const url = isAdmin ? ADMIN_CREATE_ASSESSMENT_API(courseId) : CREATE_ASSESSMENT_API(courseId)
    const res = await apiConnector("POST", url, payload, headers(token))
    return res.data
  } catch (e) { return { success: false, message: e.response?.data?.message ?? e.message } }
}

export const getInstructorAssessment = async (courseId, token, isAdmin = false) => {
  try {
    const url = isAdmin ? GET_ADMIN_ASSESSMENT_API(courseId) : GET_INSTRUCTOR_ASSESSMENT_API(courseId)
    const res = await apiConnector("GET", url, null, headers(token))
    return res.data?.data ?? null
  } catch { return null }
}

export const verifyCertificate = async (credentialId) => {
  try {
    const res = await apiConnector("GET", VERIFY_CERTIFICATE_API(credentialId))
    return res.data
  } catch (e) {
    return { success: false, message: e.response?.data?.message ?? "Certificate not found" }
  }
}
